/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface PoolTransactionPool
 */
export interface PoolTransactionPool {
  /**
   *
   * @type {string}
   * @memberof PoolTransactionPool
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof PoolTransactionPool
   */
  address?: string
}

export function PoolTransactionPoolFromJSON(json: any): PoolTransactionPool {
  return PoolTransactionPoolFromJSONTyped(json, false)
}

export function PoolTransactionPoolFromJSONTyped(json: any, ignoreDiscriminator: boolean): PoolTransactionPool {
  if (json === undefined || json === null) {
    return json
  }
  return {
    name: !exists(json, 'name') ? undefined : json['name'],
    address: !exists(json, 'address') ? undefined : json['address'],
  }
}

export function PoolTransactionPoolToJSON(value?: PoolTransactionPool | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    address: value.address,
  }
}
